import { render, staticRenderFns } from "./AddInventory.vue?vue&type=template&id=a194c64c&scoped=true&"
import script from "./AddInventory.vue?vue&type=script&lang=js&"
export * from "./AddInventory.vue?vue&type=script&lang=js&"
import style0 from "./AddInventory.vue?vue&type=style&index=0&id=a194c64c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a194c64c",
  null
  
)

export default component.exports